/* eslint-disable max-len */
import { GetEquivalentReferencesResponse } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/response/GetEquivalentReferencesResponse';
import { GetExadisEligibleReferencesResponse } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/response/GetExadisEligibleReferencesResponse';
import { GetIsDiscontinuedReferenceResponse } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/response/GetIsDiscontinuedReferenceResponse';
import { GetPlatesForReferenceResponse } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/response/GetPlatesForReferenceResponse';
import { GetReference3DModelResponse } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/response/GetReference3dModelResponse';
import { GetReuseAvailabilitiesResponse } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/response/GetReuseAvailabilitiesResponse';
import { GetReuseStockResponse } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/response/GetReuseStockResponse';
import { GetIAMReferenceApplicabilityResponse } from '@1po/1po-bff-fe-spec/generated/catalog/references/iam/response/GetIAMReferenceApplicabilityResponse';
import { CurrentReferenceStock } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/request/CheckIfStocksAreStillUpToDateRequest';
import { ReferenceStockTradingDataRequestDetail } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/request/GetReferencesStockRequest';
import { ReferenceTradingDataRequestDetail } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/request/GetReferenceTradingDataRequest';
import { CheckIfStocksAreStillUpToDateResponse } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/response/CheckIfStocksAreStillUpToDateResponse';
import { GetReferencesPriceResponse } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/response/GetReferencesPriceResponse';

import {
  GetReferencesStocksResponse,
  ReferenceStock,
} from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/response/GetReferencesStocksResponse';
import { ReferencesDiscountsResponse } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/response/ReferencesDiscountsResponse';
import { RemovedReferencesDiscountsResponse } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/response/RemovedReferencesDiscountsResponse';
import { RepairPricesResponse } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/response/RepairPricesResponse';
import { GetDMSReferencesStocksResponse } from '@1po/1po-bff-fe-spec/generated/dms/response/GetDMSReferencesStockResponse';
import { put, takeEvery } from '@redux-saga/core/effects';
import { SagaIterator } from 'redux-saga';
import { RootState } from 'app/AppStore';
import { EXADIS_PICKUP_DELIVERY_TYPE } from 'domains/basket/Basket.types';
import { getLastSearchedVehicleKey, getVehicleContext } from 'domains/catalog/Catalog.store';
import { isRefNumberDeposit } from 'domains/references/DepositReference';
import {
  sendCheckIfStocksAreStillUpToDateRequest,
  sendGetCrossSellingReferences,
  sendGetEquivalents,
  sendGetExadisEligibleReferences,
  sendGetIsDiscontinuedReferenceRequest,
  sendGetPlatesForReference,
  sendGetReference3dModelRequest,
  sendGetReferencesDiscountRequest,
  sendGetReferencesPriceRequest,
  sendGetReferencesRepairPricesRequest,
  sendGetReferencesStocksRequest,
  sendGetReuseAvailabilities,
  sendGetReuseStocks,
  sendIAMReferenceApplicabilityRequest,
} from 'domains/references/References.api';
import { sortStockWarehouses } from 'domains/references/References.mapper';
import * as actions from 'domains/references/References.store';
import {
  getPricesMap,
  getReferencesToStockInfosSnapshotMapV2,
  getStocksMapV2,
  removeReferencesDiscounts,
  setCrossSellingReferences,
  setDiscontinuedReference,
  setDiscontinuedReferenceSearchStatus,
  setDmsReferencesStocksData,
  setDmsReferencesStocksNoDataStatus,
  setEquivalentReferences,
  setEquivalentReferencesNoDataStatus,
  setExadisEligibleReferences,
  setExadisEligibleReferencesSearchStatus,
  setPlatesForReference,
  setPlatesForReferenceSearchStatus,
  setReference3dModel,
  setReferenceApplicabilities,
  setReferenceApplicabilitiesNoDataStatus,
  setReferencesDiscounts,
  setReferencesDiscountsSearchStatus,
  setReferencesPriceDataV2,
  setReferencesPriceNoDataStatusV2,
  setReferencesRepairPriceData,
  setReferencesRepairPriceNoDataStatus,
  setReferencesStocksDataV2,
  setReferencesStocksNoDataStatus,
  setReferencesStocksSnapshotData,
  setReuseAvailabilitiesData,
  setReuseAvailabilitiesNoDataStatus,
  setReuseStockData,
  setReuseStockNoDataStatus,
  setStockUpdateCheck,
} from 'domains/references/References.store';
import { getTradingProfile, getUserContext } from 'domains/user';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import { hasData, LOADING, sagaGuard, select } from 'utils';

export function* fetchPricesAndStocks(
  tradingDataRequest: ReferenceTradingDataRequestDetail[],
  stockRequest: ReferenceStockTradingDataRequestDetail[],
): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  if (tradingProfile?.isComplete() !== true) {
    return;
  }
  yield put(
    actions.fetchReferencesStocksRequestSaga({
      data: stockRequest,
    }),
  );
  yield put(
    actions.fetchReferencesPriceRequestSaga({
      references: tradingDataRequest,
      basketRequest: false,
    }),
  );
}

//like useFetchStocks hook - but here ask for every reference from request
export function* fetchStocks({ payload }: ReturnType<typeof actions.fetchStocks>): SagaIterator {
  const { requestStockDetails } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  if (tradingProfile?.isComplete() !== true || requestStockDetails.length === 0) {
    return;
  }
  yield put(
    actions.fetchReferencesStocksRequestSaga({
      data: requestStockDetails,
      fetchEvenIfExists: true,
    }),
  );
}

export function* fetchReferencesPriceRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchReferencesPriceRequestSaga>): SagaIterator {
  const { references, basketRequest } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  if (!tradingProfile?.isComplete()) return;
  const referenceNumbers = references.map((r) => r.referenceNumber);
  const prices = yield* select((state: RootState) => getPricesMap(state, referenceNumbers));
  const referencesToFetch = references.filter((r) => prices.get(r.referenceNumber) === undefined);

  if (referencesToFetch.length > 0) {
    yield put(
      setReferencesPriceNoDataStatusV2({
        referenceNumbers: referencesToFetch.map((r) => r.referenceNumber),
        status: LOADING,
      }),
    );
    yield put(sendGetReferencesPriceRequest(referencesToFetch, basketRequest));
  }
}

export function* fetchReferencesDiscountsRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchReferencesDiscountsRequestSaga>): SagaIterator {
  const { references } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  if (!tradingProfile?.isComplete()) return;
  const referenceNumbers = references.map((r) => r.referenceNumber);
  const prices = yield* select((state: RootState) => getPricesMap(state, referenceNumbers));
  const referencesToFetch = references.filter((r) => prices.get(r.referenceNumber) === undefined);

  if (referencesToFetch.length > 0) {
    yield put(
      setReferencesDiscountsSearchStatus({
        referenceNumbers: referencesToFetch.map((r) => r.referenceNumber),
        searchStatus: LOADING,
      }),
    );
    yield put(sendGetReferencesDiscountRequest(referencesToFetch));
  }
}

export function* fetchCrossSellingReferencesRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchCrossSellingReferencesRequestSaga>): SagaIterator {
  const { references, vehicleKey } = payload;
  const userContext = yield* select(getUserContext);
  const vehicleContext = yield* select((state) => getVehicleContext(state, vehicleKey ?? ''));
  const transformReferences = references.map((r) => {
    return {
      sourceReference: r,
      crossSellingReferences: [],
    };
  });
  yield put(sendGetCrossSellingReferences({ references, userContext, vehicleContext }));
  yield put(setCrossSellingReferences({ crossSellingReferences: transformReferences, vehicleKey, status: LOADING }));
}

export function* fetchCrossSellingFileReferencesResponseSaga(action: WsResponse): SagaIterator {
  const vehicleKey = yield* select(getLastSearchedVehicleKey);
  yield put(setCrossSellingReferences({ crossSellingReferences: action.payload.groups, vehicleKey }));
}

export function* fetchCrossSellingReferencesResponseSaga(action: WsResponse): SagaIterator {
  const vehicleKey = yield* select(getLastSearchedVehicleKey);
  yield put(setCrossSellingReferences({ crossSellingReferences: [action.payload.group], vehicleKey }));
}

export function* fetchReferencesPriceResponseSaga(action: WsResponse<GetReferencesPriceResponse>): SagaIterator {
  const { referencesPrice } = action.payload;
  yield put(setReferencesPriceDataV2(referencesPrice));
}

export function* fetchReferencesRepairPriceRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchReferencesRepairPriceRequestSaga>): SagaIterator {
  const { references } = payload;
  yield put(
    setReferencesRepairPriceNoDataStatus({
      referenceNumbers: references.map((r) => r.referenceNumber),
      status: LOADING,
    }),
  );
  yield put(sendGetReferencesRepairPricesRequest(references));
}

export function* fetchReferencesRepairPriceResponseSaga(action: WsResponse): SagaIterator {
  const { referencesPrice }: RepairPricesResponse = action.payload;
  yield put(setReferencesRepairPriceData(referencesPrice));
}

export function* fetchReferencesStocksRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchReferencesStocksRequestSaga>): SagaIterator {
  const { data, fetchEvenIfExists } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  if (!tradingProfile?.isComplete()) return;
  const userContext = yield* select(getUserContext);
  const referenceNumbers = data.map((d) => d.referenceNumber);
  const stocks = yield* select((state: RootState) => getStocksMapV2(state, referenceNumbers));
  const referencesToFetch = (fetchEvenIfExists === true
    ? data
    : data.filter((r) => stocks.get(r.referenceNumber) === undefined)
  ).filter((r) => !isRefNumberDeposit(r.referenceNumber));
  // pretend like no discount is present, loading state to be done maybe in future (spinners not required yet)
  if (referencesToFetch.length > 0) {
    yield put(
      setReferencesStocksNoDataStatus({
        references: referencesToFetch?.map((ref) => ref.referenceNumber),
        status: LOADING,
      }),
    );
    yield put(
      setDmsReferencesStocksNoDataStatus({
        references: referencesToFetch?.map((ref) => ref.referenceNumber),
        status: LOADING,
      }),
    );

    yield put(sendGetReferencesStocksRequest(referencesToFetch, userContext));
  }
}

export function* fetchReferencesStocksResponseSaga(action: WsResponse<GetReferencesStocksResponse>): SagaIterator {
  const { referencesStocks }: GetReferencesStocksResponse = action.payload;

  const sortedStockWarehousesArray: ReferenceStock[] = referencesStocks?.map((st) => {
    const warehouses = st.warehouses;
    const sortedWarehouses = hasData(warehouses) ? [...warehouses].sort(sortStockWarehouses) : warehouses;
    return { ...st, warehouses: sortedWarehouses };
  });
  yield put(setReferencesStocksDataV2(sortedStockWarehousesArray));
}

export function* fetchReferencesDmsStocksResponseSaga(
  action: WsResponse<GetDMSReferencesStocksResponse>,
): SagaIterator {
  const { referencesStocks }: GetDMSReferencesStocksResponse = action.payload;

  yield put(setDmsReferencesStocksData(hasData(referencesStocks) ? referencesStocks : []));
}

export function* fetchReuseStocksRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchReuseStocksRequestSaga>): SagaIterator {
  const { referenceNumbers, nodeId } = payload;
  yield put(sendGetReuseStocks(referenceNumbers, nodeId));
  yield put(
    setReuseStockNoDataStatus({
      referenceNumbers,
      status: LOADING,
    }),
  );
}

export function* fetchReuseStocksResponseSaga(action: WsResponse<GetReuseStockResponse>): SagaIterator {
  yield put(setReuseStockData(action.payload.references));
}

export function* fetchReuseAvailabilitiesRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchReuseAvailabilitiesRequestSaga>): SagaIterator {
  const { referenceNumbers } = payload;
  yield put(sendGetReuseAvailabilities(referenceNumbers));
  yield put(
    setReuseAvailabilitiesNoDataStatus({
      referenceNumbers,
      status: LOADING,
    }),
  );
}

export function* fetchReuseAvailabilitiesResponseSaga(
  action: WsResponse<GetReuseAvailabilitiesResponse>,
): SagaIterator {
  yield put(setReuseAvailabilitiesData(action.payload.availabilities));
}

export function* fetchEquivalentReferencesRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchEquivalentReferencesRequestSaga>): SagaIterator {
  const { reference } = payload;
  const userContext = yield* select(getUserContext);

  yield put(sendGetEquivalents({ reference, userContext }));
  yield put(setEquivalentReferencesNoDataStatus({ reference, status: LOADING }));
}

export function* fetchEquivalentReferencesResponseSaga(
  action: WsResponse<GetEquivalentReferencesResponse>,
): SagaIterator {
  yield put(setEquivalentReferences(action.payload.equivalentReferences));
}

export function* fetchExadisEligibleReferencesRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchExadisEligibleReferencesRequestSaga>): SagaIterator {
  const { referenceNumbers } = payload;
  const userContext = yield* select(getUserContext);

  yield put(setExadisEligibleReferencesSearchStatus({ status: LOADING }));
  yield put(sendGetExadisEligibleReferences({ referenceNumbers, userContext }));
}

export function* fetchExadisEligibleReferencesResponseSaga(
  action: WsResponse<GetExadisEligibleReferencesResponse>,
): SagaIterator {
  yield put(setExadisEligibleReferences(action.payload.eligibleReferenceNumbers));
}

export function* fetchReferenceDiscountsResponseSaga(action: WsResponse<ReferencesDiscountsResponse>): SagaIterator {
  yield put(setReferencesDiscounts(action.payload));
}

export function* fetchReferenceDiscountsRemoveResponseSaga(
  action: WsResponse<RemovedReferencesDiscountsResponse>,
): SagaIterator {
  yield put(removeReferencesDiscounts(action.payload.references));
}

export function* fetchPlatesForReferenceRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchPlatesForReferenceRequestSaga>): SagaIterator {
  const { vehicleKey, referenceNumber } = payload;
  yield put(setPlatesForReferenceSearchStatus({ vehicleKey, reference: referenceNumber, status: LOADING }));
  const vehicleContext = yield* select((state) => getVehicleContext(state, vehicleKey));
  const userContext = yield* select(getUserContext);
  yield put(
    sendGetPlatesForReference({
      vehicleContext,
      userContext,
      referenceNumber,
    }),
  );
}

export function* fetchPlatesForReferenceResponseSaga(action: WsResponse<GetPlatesForReferenceResponse>): SagaIterator {
  const { vehicleContext, referenceNumber, plates } = action.payload;
  yield put(setPlatesForReference({ vehicleKey: vehicleContext.vehicleKey, reference: referenceNumber, plates }));
}

export function* checkIfStocksAreStillUpToDateRequestSaga({
  payload,
}: ReturnType<typeof actions.checkIfStocksAreStillUpToDateRequestSaga>): SagaIterator {
  const { requestId, references } = payload;
  const refNumbers = references.map((ref) => ref.referenceNumber);
  const referencesToStockInfosV2 = yield* select((state: RootState) => getStocksMapV2(state, refNumbers));
  const referencesToStockInfosSnapshotV2 = yield* select((state: RootState) =>
    getReferencesToStockInfosSnapshotMapV2(state, refNumbers),
  );

  const currentStocks: CurrentReferenceStock[] = references.map((processingRequestedReference) => {
    const referenceNumber = processingRequestedReference.referenceNumber;
    const sellerNumber = processingRequestedReference.sellerNumber ?? 'NON_MKTP';
    const snapshotStock = referencesToStockInfosSnapshotV2?.get(referenceNumber)?.data?.get(sellerNumber);
    const refStock = referencesToStockInfosV2?.get(referenceNumber)?.data?.get(sellerNumber);
    // for some seller was primary stock requested?
    const primaryRequested =
      refStock?.primaryStockResponse && processingRequestedReference.deliveryType === EXADIS_PICKUP_DELIVERY_TYPE;

    // for some seller was primary stock requested? but not exadis pickup selected
    const primaryRequestedButNotPickup =
      refStock?.primaryStockResponse && processingRequestedReference.deliveryType !== EXADIS_PICKUP_DELIVERY_TYPE;

    const warehouses = primaryRequestedButNotPickup ? snapshotStock?.warehouses : refStock?.warehouses;
    return {
      referenceNumber,
      requestedQuantity: processingRequestedReference?.quantity ?? 1,
      type: processingRequestedReference.type ?? 'STANDARD',
      warehouses: warehouses ?? [],
      origin: processingRequestedReference.origin,
      supplierCode: processingRequestedReference.supplierCode,
      referenceSource: processingRequestedReference.referenceSource,
      primaryStock: primaryRequested,
      sellerNumber: processingRequestedReference.sellerNumber,
      isCertasReference: processingRequestedReference.isCertasReference,
    };
  });

  yield put(setStockUpdateCheck({ id: requestId, result: LOADING }));
  const userContext = yield* select(getUserContext);
  yield put(
    sendCheckIfStocksAreStillUpToDateRequest({
      requestId,
      currentStocks,
      userContext,
    }),
  );
}

export function* checkIfStocksAreStillUpToDateResponseSaga(
  action: WsResponse<CheckIfStocksAreStillUpToDateResponse>,
): SagaIterator {
  const { requestId, referenceStockDiffs, updatedStockDetails } = action.payload;
  yield put(setReferencesStocksDataV2(updatedStockDetails));
  yield put(setStockUpdateCheck({ id: requestId, result: referenceStockDiffs }));
}

export function* snapshotStocksSaga(): SagaIterator {
  yield put(setReferencesStocksSnapshotData());
}

export function* fetchIsDiscontinuedReferenceRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchIsDiscontinuedReferenceRequestSaga>): SagaIterator {
  const { referenceNumber } = payload;
  yield put(setDiscontinuedReferenceSearchStatus({ reference: referenceNumber, status: LOADING }));
  const userContext = yield* select(getUserContext);
  yield put(
    sendGetIsDiscontinuedReferenceRequest({
      userContext,
      referenceNumber,
    }),
  );
}

export function* fetchIsDiscontinuedReferenceResponseSaga(
  action: WsResponse<GetIsDiscontinuedReferenceResponse>,
): SagaIterator {
  yield put(setDiscontinuedReference(action.payload));
}

export function* fetchIAMReferenceApplicabilityRequestSaga({
  payload,
}: ReturnType<typeof actions.fetchIAMReferenceApplicabilityRequestSaga>): SagaIterator {
  const { reference } = payload;
  const userContext = yield* select(getUserContext);

  yield put(
    sendIAMReferenceApplicabilityRequest(userContext, {
      referenceNumber: reference.referenceNumber,
      supplierCode: reference?.supplierCode ?? '',
      provider: reference?.provider ?? 'RENAULT',
    }),
  );
  yield put(setReferenceApplicabilitiesNoDataStatus({ reference: reference?.referenceNumber ?? '', status: LOADING }));
}

export function* fetchIAMReferenceApplicabilityResponseSaga(
  action: WsResponse<GetIAMReferenceApplicabilityResponse>,
): SagaIterator {
  yield put(setReferenceApplicabilities(action.payload));
}

export function* sendGetReference3dModelRequestSaga({
  payload,
}: ReturnType<typeof actions.sendGetReference3dModelRequestSaga>): SagaIterator {
  const userContext = yield* select(getUserContext);
  const { reference } = payload;
  yield put(sendGetReference3dModelRequest({ userContext, referenceNumber: reference }));
}

export function* sendGetReference3dModelResponseSaga(action: WsResponse<GetReference3DModelResponse>): SagaIterator {
  yield put(setReference3dModel(action.payload));
}

export function* ReferencesSagas(): SagaIterator {
  yield takeEvery(actions.fetchReferencesPriceRequestSaga.type, sagaGuard(fetchReferencesPriceRequestSaga));
  yield takeEvery(actions.fetchReferencesPriceResponseSaga.type, sagaGuard(fetchReferencesPriceResponseSaga));
  yield takeEvery(
    actions.fetchCrossSellingReferencesRequestSaga.type,
    sagaGuard(fetchCrossSellingReferencesRequestSaga),
  );
  yield takeEvery(
    actions.fetchCrossSellingFileReferencesResponseSaga.type,
    sagaGuard(fetchCrossSellingFileReferencesResponseSaga),
  );
  yield takeEvery(
    actions.fetchCrossSellingReferencesResponseSaga.type,
    sagaGuard(fetchCrossSellingReferencesResponseSaga),
  );
  yield takeEvery(actions.fetchReferencesRepairPriceRequestSaga.type, sagaGuard(fetchReferencesRepairPriceRequestSaga));
  yield takeEvery(
    actions.fetchReferencesRepairPriceResponseSaga.type,
    sagaGuard(fetchReferencesRepairPriceResponseSaga),
  );
  yield takeEvery(actions.fetchReferencesStocksRequestSaga.type, sagaGuard(fetchReferencesStocksRequestSaga));
  yield takeEvery(actions.fetchReferencesStocksResponseSaga.type, sagaGuard(fetchReferencesStocksResponseSaga));
  yield takeEvery(actions.dmsReferencesStocksResponseSaga.type, sagaGuard(fetchReferencesDmsStocksResponseSaga));
  yield takeEvery(actions.fetchReuseStocksRequestSaga.type, sagaGuard(fetchReuseStocksRequestSaga));
  yield takeEvery(actions.fetchReuseStocksResponseSaga.type, sagaGuard(fetchReuseStocksResponseSaga));
  yield takeEvery(actions.fetchReuseAvailabilitiesRequestSaga.type, sagaGuard(fetchReuseAvailabilitiesRequestSaga));
  yield takeEvery(actions.fetchReuseAvailabilitiesResponseSaga.type, sagaGuard(fetchReuseAvailabilitiesResponseSaga));
  yield takeEvery(actions.fetchEquivalentReferencesRequestSaga.type, sagaGuard(fetchEquivalentReferencesRequestSaga));
  yield takeEvery(actions.fetchEquivalentReferencesResponseSaga.type, sagaGuard(fetchEquivalentReferencesResponseSaga));
  yield takeEvery(
    actions.fetchExadisEligibleReferencesRequestSaga.type,
    sagaGuard(fetchExadisEligibleReferencesRequestSaga),
  );
  yield takeEvery(
    actions.fetchExadisEligibleReferencesResponseSaga.type,
    sagaGuard(fetchExadisEligibleReferencesResponseSaga),
  );
  yield takeEvery(actions.fetchReferencesDiscountsRequestSaga.type, sagaGuard(fetchReferencesDiscountsRequestSaga));
  yield takeEvery(actions.fetchReferenceDiscountsResponse.type, sagaGuard(fetchReferenceDiscountsResponseSaga));
  yield takeEvery(
    actions.fetchReferenceDiscountsRemoveResponse.type,
    sagaGuard(fetchReferenceDiscountsRemoveResponseSaga),
  );
  yield takeEvery(
    actions.checkIfStocksAreStillUpToDateRequestSaga.type,
    sagaGuard(checkIfStocksAreStillUpToDateRequestSaga),
  );
  yield takeEvery(
    actions.checkIfStocksAreStillUpToDateResponseSaga.type,
    sagaGuard(checkIfStocksAreStillUpToDateResponseSaga),
  );
  yield takeEvery(actions.snapshotStocksSaga.type, sagaGuard(snapshotStocksSaga));

  yield takeEvery(actions.fetchPlatesForReferenceRequestSaga.type, sagaGuard(fetchPlatesForReferenceRequestSaga));
  yield takeEvery(actions.fetchPlatesForReferenceResponseSaga.type, sagaGuard(fetchPlatesForReferenceResponseSaga));
  yield takeEvery(actions.fetchStocks.type, sagaGuard(fetchStocks));

  yield takeEvery(
    actions.fetchIsDiscontinuedReferenceRequestSaga.type,
    sagaGuard(fetchIsDiscontinuedReferenceRequestSaga),
  );
  yield takeEvery(
    actions.fetchIsDiscontinuedReferenceResponseSaga.type,
    sagaGuard(fetchIsDiscontinuedReferenceResponseSaga),
  );
  yield takeEvery(
    actions.fetchIAMReferenceApplicabilityRequestSaga.type,
    sagaGuard(fetchIAMReferenceApplicabilityRequestSaga),
  );
  yield takeEvery(
    actions.fetchIAMReferenceApplicabilityResponseSaga.type,
    sagaGuard(fetchIAMReferenceApplicabilityResponseSaga),
  );
  yield takeEvery(actions.sendGetReference3dModelRequestSaga, sagaGuard(sendGetReference3dModelRequestSaga));
  yield takeEvery(actions.sendGetReference3dModelResponseSaga, sagaGuard(sendGetReference3dModelResponseSaga));
}
